import { ComponentProps } from 'react';
import styled, { css } from 'styled-components';

import Icon, { IconName } from '../../../common/base/Icon';

const StyledCollapsedNavIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const StyledCollapsedNavIndicator = styled.span<{ dot_color: 'danger' | 'warning' }>(
  ({ theme, dot_color }) => css`
    position: absolute;
    top: ${theme.pxToRem(0)};
    right: ${theme.pxToRem(0)};
    width: ${theme.pxToRem(6)};
    height: ${theme.pxToRem(6)};
    border: 1px solid ${theme.colors.surface.base.background};
    border-radius: 50%;
    background-color: ${dot_color === 'danger'
      ? theme.colors.on.neutral.danger
      : theme.colors.on.neutral.warning};
    pointer-events: none;
  `,
);

const CollapsedNavIcon = ({
  icon,
  dot_color,
  left,
}: {
  icon: IconName;
  dot_color?: 'danger' | 'warning';
  left?: ComponentProps<typeof Icon>['left'];
}) => (
  <StyledCollapsedNavIcon>
    <Icon left={left} icon={icon} pointer p={0.5} />
    {dot_color && <StyledCollapsedNavIndicator dot_color={dot_color} />}
  </StyledCollapsedNavIcon>
);

export default CollapsedNavIcon;
